// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3I3bp","content":"GlobalSearch_content__2PQ6w"};